'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRedux = require('react-redux');

var _PopupType = require('./../../helpers/PopupType');

var _Popup = require('./Popup.scss');

var _Popup2 = _interopRequireDefault(_Popup);

var _Product = require('../../helpers/Product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPUP_CLASSNAME = 'popup';

var Popup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    type: state.popup.type,
    auth: state.auth
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Popup, _Component);

  function Popup() {
    (0, _classCallCheck3.default)(this, Popup);
    return (0, _possibleConstructorReturn3.default)(this, (Popup.__proto__ || (0, _getPrototypeOf2.default)(Popup)).apply(this, arguments));
  }

  (0, _createClass3.default)(Popup, [{
    key: 'render',
    value: function render() {
      var popupId = this.props.type[0];
      var element = (0, _PopupType.getPopupTypeElement)(popupId);
      var customStylesId = (0, _PopupType.getPopupTypeCustomStylesId)(popupId);
      var productName = this.props.auth.productName;


      var popupBackgroundStyle = '';
      if (popupId === _PopupType.PopupId.CreatePasswordAndLinkToProfileSuccess) {
        switch (productName) {
          case _Product.PRODUCT_NAMES.Music:
            popupBackgroundStyle = _Popup2.default.musicPopupBackgroundImage;
            break;
          case _Product.PRODUCT_NAMES.Classica:
            popupBackgroundStyle = _Popup2.default.classicaPopupBackgroundImage;
            break;
          case _Product.PRODUCT_NAMES.Qello:
            popupBackgroundStyle = _Popup2.default.qelloPopupBackgroundImage;
            break;
          default:
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'fadeInOutPopup',
            transitionEnterTimeout: 200,
            transitionLeaveTimeout: 200
          },
          popupId ? _react2.default.createElement(
            'div',
            { className: [_Popup2.default.popup, POPUP_CLASSNAME].join(' '), key: popupId },
            _react2.default.createElement('div', { className: _Popup2.default.dimmer }),
            _react2.default.createElement(
              'div',
              { className: _Popup2.default.popupContainer },
              _react2.default.createElement(
                'div',
                { className: [_Popup2.default.popupContentWrapper, popupBackgroundStyle].join(' '), id: customStylesId },
                _react2.default.createElement(
                  'div',
                  { className: _Popup2.default.popupContent },
                  element
                )
              )
            )
          ) : ''
        )
      );
    }
  }]);
  return Popup;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  type: _react.PropTypes.array
}, _temp)) || _class);
exports.default = Popup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/Popup.js
// module id = 1978
// module chunks = 0